/* tslint:disable */
module ProcessList {
    import IModalInstance = angular.ui.bootstrap.IModalServiceInstance;
    import IEnvironmentData = Shared.Environments.IEnvironmentData;

    export class DeployProcessesModalController {

        public processesWithVersionData: IProcessWithVersionData[];
        public environmentsForDeployment: string[];
        public targetEnvironment: string;
        private environmentNames: any[];
        public targetAgentGroup: string;
        public rowsToShow: IProcessDeployRow[];
        public activateTriggers: boolean;
        public showAllVersions: boolean;
        static $inject = ["processes", "$uibModalInstance", "environments", "currentEnvironment", "currentAgentGroup", "isSwitchVersion", "notifications", "ProcessDataService"];
        constructor(
            private processes: IProcessWithVersionData[],
            private $modalInstance: IModalInstance,
            private environments: IEnvironmentData[],
            private currentEnvironment: string,
            private currentAgentGroup: string,
            private isSwitchVersion: boolean,
            private notifications: INotifications,
            private processDataService: ProcessDataService) {
            this.activateTriggers = true;
            this.environmentNames = _.map(this.environments, env => { return { name: env.name, displayName: env.displayName } } );
            this.processesWithVersionData = this.getProcessWithVersionData(this.processes);

            this.environmentsForDeployment = _.difference(this.environmentNames.map(x=>x.name), [currentEnvironment, EnvironmentVariables.DEFAULT_ENV_NAME]);
            if (this.environmentsForDeployment.length === 0) {
                notifications.error(FRENDS.Localizations.Deploy_NoEnvironmentsToDeployTo);
                throw "No environments to deploy to: cannot deploy to current environment or the default environment";
            }

            if (isSwitchVersion) {
                this.targetEnvironment = EnvironmentVariables.DEFAULT_ENV_NAME;
                this.targetAgentGroup = EnvironmentVariables.DEFAULT_ENV_NAME;
            } else {
                this.targetEnvironment = this.environmentsForDeployment[0];
                this.targetAgentGroup = _.find(this.environments, env => env.name == this.targetEnvironment)
                    .agentGroups[0].name;
            }
        }

        public getProcessWithVersionData(processes: IProcessWithVersionData[]) {
            return <IProcessWithVersionData[]>_.map(processes, orig => {
                let p: IProcessWithVersionData = angular.copy(orig);
                p.versionToDeploy = orig.version;
                p.minorToDeploy = orig.minorVersion;
                p.majorToDeploy = orig.majorVersion;
                p.rowsToShow = [];

                if (this.showAllVersions) {
                    for (var versionInfo of p.existingVersions) {
                        for (var buildVersion of _.sortBy(versionInfo.versions)) {
                            let descriptionEntry = _.find(versionInfo.changeDescriptions, d => d.versionNumber == buildVersion)
                            p.rowsToShow.push({
                                majorVersion: versionInfo.majorVersion,
                                minorVersion: versionInfo.minorVersion,
                                version: buildVersion,
                                changeDescription: descriptionEntry && descriptionEntry.changeDescription,
                                environments: versionInfo.deployedProcessVersions
                                    .filter(d => d.versionNumber === buildVersion)
                                    .map(d => this.getEnvironmentName(d.environmentName))
                                    .join(','),
                            });
                        }
                    }
                } else {
                    //For each existing major.minor version under the process
                    _.each(p.existingVersions, x => {
                        var grpd = _.groupBy(x.deployedProcessVersions, 'versionNumber')
                        if (_.isEmpty(grpd)) {
                            p.rowsToShow.push({
                                majorVersion: x.majorVersion,
                                minorVersion: x.minorVersion,
                                version: _.first(x.versions),
                                environments: ""
                            })
                        } else {
                            _.each(grpd, (grpdX, key) =>
                                p.rowsToShow.push({
                                    majorVersion: x.majorVersion,
                                    minorVersion: x.minorVersion,
                                    version: parseInt(key),
                                    environments: _.map(grpdX, f => this.getEnvironmentName(f.environmentName)).join(",")
                                }));
                        }
                    });
                }
                return p;
            });
        };
        public getEnvironmentName(sourceEnv: string) {
            return _.find(this.environmentNames, x => x.name === sourceEnv).displayName;
        }

        public updateVersionListShowingAllVersions() {
            this.showAllVersions = true;
            this.processesWithVersionData = this.getProcessWithVersionData(this.processes);
        }

        public deploy() {
            this.processDataService.deployProcesses(this.processesWithVersionData, this.targetEnvironment, this.targetAgentGroup, this.isSwitchVersion, this.activateTriggers)
                .then(response => {
                    if (response && response.success) {
                        this.notifications.notify(response.data);
                        this.$modalInstance.close();
                    }
                });
        };

        public setVersionToDeploy(process: IProcessWithVersionData, majorVersion: number, minorVersion: number, buildVersion: number) {
            process.versionToDeploy = buildVersion;
            process.majorToDeploy = majorVersion;
            process.minorToDeploy = minorVersion;
        };
         
        public setTargetEnvironment(env: string) {
            this.targetEnvironment = env;
            this.targetAgentGroup = env;
        };

        public shouldShowDowngradeWarning(process: IProcessWithVersionData) {
            var foundProcessVersions = _.find(process.existingVersions, ev => ev.deployedProcessVersions.some(x => x.environmentName === this.targetEnvironment));
            if (foundProcessVersions) {
                var currentVersionNumber = _.first(foundProcessVersions.deployedProcessVersions.filter(x => x.environmentName === this.targetEnvironment)).versionNumber;
                return process.versionToDeploy < currentVersionNumber;
            }
        };
    }

    module.controller("DeployProcessesModalController", DeployProcessesModalController);

    interface IProcessWithVersionData extends IProcessData {
        versionToDeploy: number;
        majorToDeploy: number;
        minorToDeploy: number;
        rowsToShow: IProcessDeployRow[];
    }

    interface IProcessDeployRow {
        majorVersion: number;
        minorVersion: number;
        version: number;
        environments: string;
        changeDescription?: string;
    }
}
